export default __webpack_public_path__ + "static/media/powered_by_doforms.22e0f283.png";